const VERTICAL_GAP = 10;
const HORIZONTAL_OFFSET = 5;
export const setFloatingElemPosition = (targetRect: DOMRect | null, floatingElem: HTMLElement, anchorElem: HTMLElement) => {
  const scrollerElem = anchorElem.parentElement;
  if (targetRect === null || !scrollerElem) {
    floatingElem.style.opacity = '0';
    floatingElem.style.transform = 'translate(-10000px, -10000px)';
    return;
  }
  const floatingElemRect = floatingElem.getBoundingClientRect();
  const anchorElemRect = anchorElem.getBoundingClientRect();
  const editorScrollerRect = scrollerElem.getBoundingClientRect();
  let top = targetRect.top - VERTICAL_GAP;
  let left = targetRect.left - HORIZONTAL_OFFSET;
  if (top < editorScrollerRect.top) {
    top += floatingElemRect.height + targetRect.height + VERTICAL_GAP * 2;
  }
  if (left + floatingElemRect.width > editorScrollerRect.right) {
    left = editorScrollerRect.right - floatingElemRect.width - HORIZONTAL_OFFSET;
  }
  top -= anchorElemRect.top;
  left -= anchorElemRect.left;
  floatingElem.style.opacity = '1';
  floatingElem.style.transform = `translate(${left}px, ${top}px)`;
};